
<template>
  <div class="lecturerList" :class="{ isIosx: isIosx }">
    <van-sticky>
      <div class="lecturerListNav">
        <img
          class="navLeft"
          @click="prev()"
          src="./../../assets/school/backh.png"
        />
        <span class="navTitle">讲师列表</span>
      </div>
    </van-sticky>
    <div class="lecturerListContent">
      <div
        class="lecturerListItem"
        v-for="(item, index) in dataList"
        :key="index"
        @click="toLecturerDetail(item.id)"
      >
        <img v-if="item.head_pic" :src="item.head_pic" class="img" />
        <img v-else src="./../../assets/school/defaultAvatar.png" class="img" />
        <div>
          <p class="title">{{ item.name }}</p>
          <p class="dec">
            {{ item.desc }}
          </p>
        </div>
        <img src="./../../assets/school/right.png" class="right" />
      </div>
      <div class="btm_tip">
        <p>没有更多了</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isIosx: false,
      dataList: [],
      lecturer_ids: {},
      default_img: require("./../../assets/school/defaultAvatar.png"),
    };
  },
  mounted() {
    this.isIosx = this.isIphoneX();
    if (JSON.parse(sessionStorage.getItem("token"))) {
      this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    }
    if (this.$route.query.lecturer_ids) {
      this.lecturer_ids = JSON.parse(this.$route.query.lecturer_ids);
      this.getData();
    }
  },
  methods: {
    prev() {
      this.$router.go(-1);
    },
    toLecturerDetail(id) {
      // console.log(id)
      this.$router.push({
        path: "/school/lecturerDetails",
        query: {
          id: id,
        },
      });
    },
    getData() {
      // console.log(this.lecturer_ids);
      this.$api
        .post("school/member/tab/more/lecturer", {
          lecturer_ids: this.lecturer_ids,
        })
        .then((res) => {
          this.dataList = res;
        });
    },
  },
};
</script>

<style scoped>
.lecturerList {
  background-color: #f7f8fc;
  min-height: 100%;
}
.lecturerListNav {
  color: #404247;
  height: 22px;
  padding-top: 38px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 11px;
  background-color: #ffffff;
  position: relative;
}
.lecturerListNav .navLeft {
  position: absolute;
  left: 16px;
  width: 24px;
  height: 24px;
}
.lecturerListNav .navTitle {
  font-size: 17px;
  font-weight: bold;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
/* content */
.lecturerListContent {
  margin: 0 16px;
  padding-bottom: 40px;
}
.lecturerListItem {
  background-color: #ffffff;
  margin-top: 16px;
  height: 64px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
}
.lecturerListItem .img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.lecturerListItem > div {
  display: flex;
  flex-direction: column;
  margin: 0 8px;
  flex: 1;
}
.lecturerListItem > div .title {
  font-weight: 700;
  color: #404247;
  font-size: 15px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}
.lecturerListItem > div .dec {
  font-weight: 400;
  color: #9ca1ad;
  font-size: 12px;
  line-height: 17px;
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}
.lecturerListItem .right {
  width: 12px;
  height: 12px;
}

.btm_tip {
  display: flex;
  justify-content: center;
}
.btm_tip p {
  font-size: 14px;
  font-weight: 400;
  color: #9ca1ad;
  line-height: 20px;
  text-align: center;
  margin: 32px 0;
}

.isIosx .lecturerListNav {
  padding-top: 44px;
}
</style>